module.exports = __webpack_public_path__ + "img/hezuo02.65dd151c.jpg";